import React from 'react'
import Navbar from '../Navbar/navbar';
import Footer from '../Footer/footer';
import ViewDress from './viewDress';
import FooterDoodles from '../Footer/footerDoodles';

function ProductPage() {
  return (
    <>
    <Navbar/>
    <ViewDress/>
    <FooterDoodles/>
    <Footer/>
    </>
  )
}

export default ProductPage;